import { useQuery } from 'react-query';

import { IPaging, IQueryParameters } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getCustomFilter } from 'modules/_common/api';

interface IProps extends IPaging, IQueryParameters {
  enabled?: boolean;
}

export const useQueryCustomFilter = ({ params, enabled = true }: IProps) => {
  return useQuery(
    [QUERY_KEYS.RESERVATION_NEW_CUSTOM_FILTER, params],
    () => getCustomFilter({ params }),
    { enabled },
  );
};
